import { IACError } from '../iacError';
import { TYPES } from '../constants';
import { IACProtocol } from '../transport/iacProtocol';
import { IACTransport } from '../transport/iacTransport';
import { IACSendingInformation } from '../application/baseApplication';

export class IACMessage {

  public protocol: IACProtocol;
  public transport: IACTransport;

  /*
   * Sends the message to the related target.
   * @param {object} target - Defines the target element
   */
  public send(target: IACSendingInformation): void {
    if (typeof target !== 'object' || !target.contentWindow || !target.iacAppname) {
      throw new IACError(`IACMessage ${this.getName()}: No valid message target given.`);
    }

    this.checkFlags(this.protocol.getFlags());

    if (this.transport.initialized()) {
      this.transport.send(this.protocol.getRawData(), target);
    }
  }

  /*
   * Sets the name of the message
   * @param {string} name -The name which has to be set
   */
  public setName(name: string): void {
    this.protocol.setName(name);
  }

  /*
   * Returns the name of the message
   * @returns {string}
   */
  public getName(): string {
    return this.protocol.getName();
  }

  /*
   * Returns the name of the sender
   * @returns {string}
   */
  public getSender(): string {
    return this.protocol.getSender();
  }

  /*
   * Sets as many arguments as needed for the payload.
   * @returns {IACMessage}
   */
  public setPayload(...args: any[]): void {
    this.protocol.setPayload(...args);
  }

  /*
   * Returns the payload
   * @returns {object}
   */
  public getPayload(): any {
    return this.protocol.getPayload();
  }

  private checkFlags(flags: number): number {
    if (typeof flags !== 'number') {
      throw new IACError('Wrong data type for flags. flags must be numeric.', 'Use_case_wrong_flagged');
    }

    if (TYPES.USECASE & flags && TYPES.EVENT & flags) {
      throw new IACError('You cannot flag a IAC message as USECASE and EVENT.', 'Use_case_wrong_flagged');
    }

    if (!(TYPES.USECASE & flags) && !(TYPES.EVENT & flags)) {
      throw new IACError('You must flag a IAC message as USECASE or EVENT', 'Use_case_wrong_flagged');
    }

    if (TYPES.RPC & flags && TYPES.RPE & flags) {
      throw new IACError('You cannot flag a IAC message as RPC and RPE.', 'Use_case_wrong_flagged');
    }

    if (!(TYPES.RPC & flags) && !(TYPES.RPE & flags)) {
      throw new IACError('You must flag a IAC message as RPC or RPE', 'Use_case_wrong_flagged');
    }

    if (TYPES.INTERN & flags && TYPES.EXTERN & flags) {
      throw new IACError('You cannot flag a IAC message as INTERN and EXTERN.', 'Use_case_wrong_flagged');
    }

    if (!(TYPES.INTERN & flags) && !(TYPES.EXTERN & flags)) {
      throw new IACError('You must flag a IAC message as INTERN or EXTERN', 'Use_case_wrong_flagged');
    }

    return flags;
  }
}
